import * as React from "react";

export const CenterLabelLayer = (label) => (layerProps) => {
  const { centerX, centerY } = layerProps;

  return (
    <text
      x={centerX}
      y={centerY}
      textAnchor="middle"
      dominantBaseline="central"
      style={{
        fontSize: "24px",
        fontWeight: "600"
      }}
    >
      {label}
    </text>
  );
};